module.exports = __webpack_public_path__ + "img/nav07.b70b9df9.png";